function readStoredSession () {
    try {
        const raw = localStorage.getItem('token');
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
            return null;
        }
        return parsed;
    } catch (e) {
        return null;
    }
}

export function getStoredSession () {
    return readStoredSession();
}

export function getBearerToken () {
    const session = readStoredSession();
    if (!session) {
        return null;
    }
    return session.token
        || session.access_token
        || session.plainTextToken
        || session.id
        || null;
}

export function authHeaders () {
    const bearer = getBearerToken();
    if (!bearer) {
        return {};
    }
    return { Authorization: `Bearer ${bearer}` };
}
